import React from "react";
import { Card } from "react-bootstrap";

function CardItem(props: any) {
  return (
    <Card className="mb-3 form-container card-width">
      <div className="card-item">{props.children}</div>
    </Card>
  );
}

export default CardItem;
